import {Component, OnInit} from '@angular/core';
import {NgFor} from '@angular/common';
import {TranslocoPipe} from '@jsverse/transloco';
import {AuthenticationService} from '../../services/authentication/authentication.service';
import {LanguageService, SupportedLanguage} from '../../services/language/language.service';
import {UserService} from '../../services/user/user.service';
import {RouterLink} from '@angular/router';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [
    TranslocoPipe,
    NgFor,
    RouterLink
  ],
  templateUrl: './footer.html',
  styleUrl: './footer.scss'
})
export class Footer implements OnInit {
  public supportedLanguages: SupportedLanguage[] = [];
  public activeLanguage = 'en';

  public constructor(
    private readonly authenticationService: AuthenticationService,
    private readonly languageService: LanguageService,
    private readonly userService: UserService,
  ) {
  }

  public ngOnInit(): void {
    this.supportedLanguages = this.languageService.getSupportedLanguages();
    this.activeLanguage = this.languageService.getActiveLanguage();
  }

  public onLanguageChange(event: Event): void {
    const target = event.target as HTMLSelectElement | null;
    if (!target) {
      return;
    }

    const normalized = this.languageService.setActiveLanguage(target.value);
    if (!normalized) {
      return;
    }

    this.activeLanguage = normalized;

    const user = this.authenticationService.getCurrentUser();
    if (user) {
      this.userService.updatePreferredLanguage(normalized).subscribe({
        error: () => {
          this.languageService.persistPreferredLanguage(normalized);
        }
      });
    } else {
      this.languageService.persistPreferredLanguage(normalized);
    }
  }
}
